import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableFooter from '@mui/material/TableFooter';
import Tooltip from '@mui/material/Tooltip';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import { FormControl, Select, MenuItem } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CloseIcon from '@mui/icons-material/Close';
import dayjs from 'dayjs';

import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'; // ไอคอนสำหรับ PDF
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'; // ไอคอนสำหรับไฟล์อื่นๆ
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import CancelIcon from '@mui/icons-material/Cancel';
import UploadIcon from '@mui/icons-material/Upload';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { useDiscountPrepaidMutation } from '../../services/paymentTransaction';
import { addCommas } from '../../utils/functions/commas';
import { useTranslation } from 'react-i18next';

const customCellHeader = {
  whiteSpace: 'nowrap',
  backgroundColor: 'primary.main',
  color: 'white',
  padding: '14px',
};

const customCellData = {
  // whiteSpace: 'nowrap',
  fontSize: '12px',
  padding: '2px',
};

 const customCellInvAndSo = {
    fontSize: '12px',
    padding: '2px',
    fontFamily: 'monospace',
  };


const PAYMENT = 'Payment';

function PaymentInvDialog({
  openPay,
  setOpenPay,
  selectedRows,
  textPay,
  selectWHT,
  setSelectWHT,
  calTotal,
  setCalTotal,
  handleOnClick,
  setAnnotation,
  annotation,
  selectWHTRate,
  setSelectWHTRate,
  isAdmin,
  setSelectedWht,
}) {
  const [discount, responseDiscount] = useDiscountPrepaidMutation();
  const [importFileWHT, setImportFileWHT] = useState([]);
  const [hideWHTMenu, setHideWHTMenu] = useState(false);
  const { t } = useTranslation();

  const isWhtBlockedRow = (row = {}) => {
    const soNumber = String(row?.so_number || '').trim();
    const invoiceNo = String(row?.invoice_no || '').trim();
    const blockedSoPrefixes = ['SO02', 'SO12', 'SO13', 'SO09', 'SO07', 'SO05'];

    return (
      !soNumber ||
      blockedSoPrefixes.some((prefix) => soNumber.startsWith(prefix)) ||
      invoiceNo.startsWith('BOI')
    );
  };

  const isSelected = (row) =>
    selectWHT.some((value) => value.invoice_no === row.invoice_no);

  const handleSelectWHT = (row) => {
    if (isWhtBlockedRow(row)) return;

    setSelectedWht((prevSelectedWht) => {
      // ถ้า prevSelectedWht ไม่ใช่ array ให้ตั้งค่าเป็น array เปล่า
      if (!Array.isArray(prevSelectedWht)) {
        prevSelectedWht = [];
      }

      // ตรวจสอบว่ามี row อยู่ใน selectedWht หรือไม่
      const index = prevSelectedWht.findIndex(
        (selectedRow) => selectedRow.invoice_no === row.invoice_no,
      );

      if (index === -1) {
        // ถ้า row ไม่ได้อยู่ใน selectedWht, ให้เพิ่ม row และตั้งค่า wht_selected เป็น true
        return [...prevSelectedWht, { ...row, wht_selected: false }];
      }
      // ถ้า row อยู่ใน selectedWht, ให้สร้างสำเนาของ prevSelectedWht และสลับค่า wht_selected
      const newSelectedWht = [...prevSelectedWht];
      newSelectedWht[index] = {
        ...newSelectedWht[index],
        wht_selected: !newSelectedWht[index].wht_selected,
      };
      return newSelectedWht;
    });

    // อัพเดท selectWHT
    if (isSelected(row)) {
      setSelectWHT(
        selectWHT.filter(
          (selectedRow) => selectedRow.invoice_no !== row.invoice_no,
        ),
      );
    } else {
      setSelectWHT([
        ...selectWHT,
        {
          invoice_no: row.invoice_no,
          period: row.period,
          so_number: row.so_number,
        },
      ]);
    }
  };

  // const handleFileUploadWHT = (event) => {
  //   const { files } = event.target;
  //   const folderFiles = Array.from(files); // Use Array.from to convert FileList to array
  //   setImportFileWHT((prevFiles) => [...prevFiles, ...folderFiles]);
  // };

  const handleDiscount = async () => {
    const payload = {
      body: {
        wht_check: selectWHT,
        row: selectedRows,
        wht_rate: selectWHTRate,
        is_upload: false,
      },
    };
    const res = await discount(payload);
    setCalTotal(res?.data?.data);
  };

  const handleChangeNote = (e) => {
    if (textPay.title === 'To Pay') {
      setAnnotation({ ...annotation, topayNote: e.target.value });
    } else {
      setAnnotation({ ...annotation, paymentNote: e.target.value });
    }
  };
  const handleClose = () => {
    // setSelectWHT([]);
    setAnnotation({
      ...annotation,
      topayNote: '',
      paymentNote: '',
    });
    setOpenPay(false);
  };

  // const formatFileSize = (size) => {
  //   if (size < 1024) return `${size} B`;
  //   if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
  //   return `${(size / (1024 * 1024)).toFixed(2)} MB`;
  // };

  // const handleDeleteWHT = (fileWHTDelete) => () => {
  //   setImportFileWHT((fileWHT) => fileWHT.filter((fileWHT) => fileWHT.name !== fileWHTDelete.name));
  // };

  // useEffect(() => {
  //   handleDiscount();
  // }, [selectWHT, selectWHTRate]);

  useEffect(() => {
    if (openPay) {
      handleDiscount();
    }
  }, [openPay, selectWHTRate, selectWHT]);

  useEffect(() => {
    // ตรวจสอบว่ามี checkbox ใดถูกเลือกหรือไม่
    const isAnyRowSelected = selectWHT.length > 0;

    // ตรวจสอบว่า checkbox ทั้งหมดถูกปิดการใช้งานหรือไม่
    const areAllRowsDisabled =
      selectWHT.length === 0 || selectWHT.every((row) => isWhtBlockedRow(row));

    // กรณีที่ checkbox ไม่มีการเลือกและทุก checkbox ถูกปิดการใช้งาน
    if (!isAnyRowSelected || areAllRowsDisabled) {
      setHideWHTMenu(true);
      setSelectWHTRate(0);
    } else {
      setHideWHTMenu(false);
      setSelectWHTRate(3);
    }
  }, [selectWHT]);

  const parseDate = (str) => {
    // "20251001" -> "2025-10-01"
    const year = str.slice(0, 4);
    const month = str.slice(4, 6);
    const day = str.slice(6, 8);
    return new Date(`${year}-${month}-${day}`);
  };

  return (
    <>
      <Dialog
        open={openPay}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            handleClose(event, reason);
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          '& .MuiDialog-paper': {
            width: '100%',
            maxWidth: 'none',
            height: '100%',
          },
        }}
      >
        <DialogTitle id="alert-dialog-title">
          <div className="flex justify-between">
            <div className="text-green-600 font-bold">
             {t('app.paymentSummary')}
            </div>
            <div>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </div>
          </div>
          <div> 

            <div className="text-green-600">
              {' '}
              {textPay.title}
            </div>
          </div>
        </DialogTitle>

        <DialogContent>
          <div className="flex flex-col lg:flex-row justify-between lg:h-full">
            <div className="w-full  border-dashed border-gray-300 border-2 p-2 md:border-0 md:flex-[2] md:pr-4 overflow-y-auto">
              <div className=" md:border-2">
                <TableContainer sx={{ maxHeight: 450 }}>
                  <Table stickyHeader aria-label="simple table ">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.invoiceNo')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.period')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.saleOrder')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.serviceName')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.startDate')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.endDate')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.paymentType')}
                        </TableCell>
                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.totalAmount')}
                        </TableCell>

                        <TableCell align="center" sx={customCellHeader}>
                          {t('app.wht')}
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    {_.size(selectedRows) ? (
                      <TableBody>
                        {selectedRows
                          .slice()
                          .sort(
                            (a, b) =>
                              parseDate(a.period_start_date) -
                              parseDate(b.period_start_date),
                          )
                          .map((row, index) => (
                            <TableRow
                              key={index}
                              sx={{
                                '&:last-child td, &:last-child th': {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell align="center" sx={customCellInvAndSo}>
                                {row.invoice_no}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                {row.period}
                              </TableCell>
                              <TableCell align="center" sx={customCellInvAndSo}>
                                {row.so_number}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                {row.service_name}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                {dayjs(row.period_start_date).format(
                                  'DD MMM YYYY',
                                )}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                {dayjs(row.period_end_date).format(
                                  'DD MMM YYYY',
                                )}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                {row.payment_type}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                {addCommas(row.invoice_amount_exclude_vat)}
                              </TableCell>
                              <TableCell align="center" sx={customCellData}>
                                <Tooltip
                                  title={
                                    isWhtBlockedRow(row)
                                      ? 'เนื่องจากรายการนี้ไม่สามารถหัก WHT ได้'
                                      : ''
                                  }
                                >
                                  <span>
                                    <Checkbox
                                      sx={{
                                        '&.Mui-disabled': {
                                          color: '#DCDCDC',
                                        },
                                      }}
                                      checked={
                                        isWhtBlockedRow(row) ? false : isSelected(row)
                                      }
                                      onChange={() => handleSelectWHT(row)}
                                      disabled={isWhtBlockedRow(row)}
                                    />
                                  </span>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    ) : (
                      <TableBody>
                        <TableRow>
                          <TableCell colSpan={10} align="center">
                            <div>ไม่มีข้อมูล</div>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                    <TableFooter className="bg-gray-200 sticky bottom-0 border-t-2 border-gray-600 ">
                      <TableRow>
                        <TableCell colSpan={6} />
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                          {t('app.totalAmount')}
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: 'bold' }}>
                          {addCommas(calTotal?.total_amount)}
                        </TableCell>
                        <TableCell />
                      </TableRow>
                    </TableFooter>
                  </Table>
                </TableContainer>
              </div>

              <div className="mt-4">
                <div className="mt-2">
                  <ErrorOutlineOutlinedIcon sx={{ color: 'red' }} />
                  <span className="ml-2 text-xs xl:text-sm">
                    {t('app.boiExemptInfo')}
                    <Link
                      href="BOICloud.pdf"
                      underline="hover"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t('app.downloadFile')}
                    </Link>
                  </span>
                </div>

                <div className="xl:mt-2">
                  <ErrorOutlineOutlinedIcon sx={{ color: 'red' }} />
                  <span className="ml-2 text-xs xl:text-sm">
                    {t('app.offlinePaymentSteps')}
                  </span>
                </div>

                <div className="text-xs xl:text-sm xl:ml-8">
                  {t('app.offlineStep1')}
                </div>

                <div className="text-xs xl:text-sm xl:ml-8">
                  {t('app.offlineStep2')}
                  <UploadFileIcon sx={{ color: '#818181' }} />
                </div>
              </div>
              <div className=" mt-5   border-2 border-gray-900 w-[100%]  rounded-md border-dashed bg-gray-100">
                <div className="ml-2 mt-2">
                  <div> {t('app.remark')}</div>
                  <textarea
                    className="w-full h-[60px] border-none focus:outline-none bg-gray-100 resize-none"
                    onChange={handleChangeNote}
                    label
                  />
                </div>
              </div>
            </div>

            {/* กล่องขวา */}
            <div className="w-full md:flex-[1] mt-5 border-dashed border-gray-300 border-2   md:mt-0 md:border-l md:border-gray-200  overflow-y-auto ">
              <div className="flex-1 p-4 space-y-6">
                <div>
                  <div className="p-3 bg-gray-50 rounded-lg border border-gray-200 divide-y divide-gray-200">
                    <div className="flex justify-between py-2 font-bold">
                      <span>{t('app.pay')}</span>
                      <span>
                        {' '}
                        {selectedRows.length} {t('app.xPeriods')}
                      </span>
                    </div>
                    <div className="flex justify-between items-center pt-2 font-bold">
                      <span> {t('app.payTo')}</span>
                      <span className="text-right text-sm">
                        {selectedRows[0]?.customer?.sorgname}
                      </span>
                    </div>
                  </div>
                </div>

     
                <div className="space-y-2">
                  <div className="flex justify-between font-bold">
                    <span>{t('app.totalAmount')}</span>
                    <span>{addCommas(calTotal?.total_amount)}</span>
                  </div>
                  <div className="flex justify-between text-red-600 font-bold">
                    {/* ใช้ข้อมูลจาก Code 2 */}
                    <span>{t('app.discount')}(1.5%)</span>
                    <span>{addCommas(calTotal?.discount)}</span>
                  </div>
                  <div className="flex justify-between font-bold">
                    <span>{t('app.vat')}(7%)</span>
                    <span>{addCommas(calTotal?.total_vat)}</span>
                  </div>
                </div>

     
                {!hideWHTMenu && (
                  <div className="space-y-4 pt-6 border-t border-gray-200">
                    {/* เพิ่ม Header แบบ Code 1 */}
                    <h3 className="text-lg font-semibold text-gray-800">
                     {t('app.wht')}
                    </h3>

                    {/* WHT Rate Selector - จัด class ใหม่ */}
                    <div className="flex justify-between items-center">
                      <span className="ml-1 font-bold">{t('app.wht')}(%)</span>
                      <FormControl sx={{ minWidth: 120 }}>
                        <Select
                          value={selectWHTRate}
                          size="small"
                          required
                          endAdornment={
                            <InputAdornment
                              position="end"
                              sx={{ marginRight: '20px', color: '#d6d6d6' }}
                            >
                              %
                            </InputAdornment>
                          }
                          onChange={(e) => {
                            setSelectWHTRate(e.target.value);
                          }}
                          inputProps={{
                            style: { padding: '1px', height: '30px' },
                          }}
                        >
                          <MenuItem value={1}>1</MenuItem>
                          <MenuItem value={3}>3</MenuItem>
                        </Select>
                      </FormControl>
                    </div>

                    {/* WHT Info Box - ใช้กล่อง 'bg-gray-50' แบบ Code 1 */}
                    <div className="p-3 text-xs bg-gray-50 rounded-lg border border-gray-200 space-y-2">
                      <div className="text-gray-600">
                        {t('app.boiExemptInfo')}
                        <Link
                          href="BOICloud.pdf"
                          underline="hover"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                         {t('app.downloadFile')}
                        </Link>
                      </div>
                      <div className="text-yellow-700">
                       {t('app.whtContact')}
                      </div>
                    </div>

                    <div></div>
                  </div>
                )}

                <div className="space-y-2 pt-6 border-t border-gray-200">
                  {!hideWHTMenu && (
                    <div className="flex justify-between text-green-600 font-medium">
                      <span>  {t('app.whtAmount')}</span>
                      <span>{addCommas(calTotal?.whtAmount)}</span>
                    </div>
                  )}
                  <div className="flex justify-between font-bold text-xl text-gray-900">
                    <span>{t('app.grandTotalThb')}</span>
                    <span>{addCommas(calTotal?.grandTotal)}</span>
                  </div>
                </div>
              </div>{' '}
              <div className="sticky bottom-0 bg-white p-4 border-t border-gray-200">
                <div className="flex flex-col gap-2">
                  <Button
                    variant="contained"
                    sx={{ color: 'white' }}
                    onClick={handleOnClick}
                    disabled={
                      isAdmin &&
                      (textPay.title === 'PAYMENT' ||
                        textPay.title === 'To Pay')
                    }
                    fullWidth // เพิ่ม fullWidth
                  >
                    {textPay.textButton}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default PaymentInvDialog;
